export const exportToCSV = (data, filename = "export.csv") => {
    const csvRows = [
      ["Name", "Email", "Submitted At"],
      ...data.map(lead => [
        lead.name,
        lead.email,
        new Date(lead.createdAt).toLocaleString()
      ]),
    ];
  
    const csvContent = csvRows.map(row => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  